<template>
  <div>
    <div
      :class="
        'grey--text text-h5 text-sm-h4 text-md-h3 text-lg-h2 font-weight-bold text-center' +
        (!center ? ' text-sm-left' : '')
      "
    >
      <slot />
    </div>

    <div
      :class="
        'text-h6 text-md-h5 grey--text text--lighten-3 text-uppercase font-weight-medium font-italic mt-4 mb-3 text-center' +
        (!center ? ' text-sm-left' : '')
      "
      v-if="category"
    >
      {{ category }}
    </div>

    <div :class="'text-center ' + (!center ? ' text-sm-left' : '')">
      <v-sheet
        color="secondary"
        class="d-inline-block"
        height="5px"
        width="100px"
      ></v-sheet>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    category: {
      type: String,
      default: "",
    },
  },
};
</script>
